export default "__VITE_ASSET__DZCXXuyf__"